<!-- No labels message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noLabels && !loading"
>
  {{ 'info.no_labels' | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div
  class="table-wrapper"
  [class.loading]="loading"
  [style.min-height.px]="containerHeight"
  *ngIf="!noLabels"
>
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table mat-table [dataSource]="items" class="spotlab-table" matSort [class.dimmed]="loading">
  <!-- Dynamic language columns based on user preference -->
  <ng-container [matColumnDef]="LabelColumn.LANG_1">
    <th mat-header-cell *matHeaderCellDef class="lang-cell">
      {{ getLanguageForColumn(0) | uppercase }}
    </th>
    <td
      mat-cell
      *matCellDef="let label"
      class="lang-cell"
      [matTooltip]="getLabelValue(label.languages, getLanguageForColumn(0))"
      [matTooltipShowDelay]="1000"
    >
      {{ getLabelValue(label.languages, getLanguageForColumn(0)) }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="LabelColumn.LANG_2">
    <th mat-header-cell *matHeaderCellDef class="lang-cell">
      {{ getLanguageForColumn(1) | uppercase }}
    </th>
    <td
      mat-cell
      *matCellDef="let label"
      class="lang-cell"
      [matTooltip]="getLabelValue(label.languages, getLanguageForColumn(1))"
      [matTooltipShowDelay]="1000"
    >
      {{ getLabelValue(label.languages, getLanguageForColumn(1)) }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="LabelColumn.LANG_3">
    <th mat-header-cell *matHeaderCellDef class="lang-cell">
      {{ getLanguageForColumn(2) | uppercase }}
    </th>
    <td
      mat-cell
      *matCellDef="let label"
      class="lang-cell"
      [matTooltip]="getLabelValue(label.languages, getLanguageForColumn(2))"
      [matTooltipShowDelay]="1000"
    >
      {{ getLabelValue(label.languages, getLanguageForColumn(2)) }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="LabelColumn.LANG_4">
    <th mat-header-cell *matHeaderCellDef class="lang-cell">
      {{ getLanguageForColumn(3) | uppercase }}
    </th>
    <td
      mat-cell
      *matCellDef="let label"
      class="lang-cell"
      [matTooltip]="getLabelValue(label.languages, getLanguageForColumn(3))"
      [matTooltipShowDelay]="1000"
    >
      {{ getLabelValue(label.languages, getLanguageForColumn(3)) }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="LabelColumn.LANG_5">
    <th mat-header-cell *matHeaderCellDef class="lang-cell">
      {{ getLanguageForColumn(4) | uppercase }}
    </th>
    <td
      mat-cell
      *matCellDef="let label"
      class="lang-cell"
      [matTooltip]="getLabelValue(label.languages, getLanguageForColumn(4))"
      [matTooltipShowDelay]="1000"
    >
      {{ getLabelValue(label.languages, getLanguageForColumn(4)) }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="LabelColumn.UUID">
    <th mat-header-cell *matHeaderCellDef class="uuid-cell">
      {{ 'UUID' | uppercase }}
    </th>
    <td
      mat-cell
      *matCellDef="let label"
      class="uuid-cell last-data-cell"
      [matTooltip]="label.uuid"
      [matTooltipShowDelay]="1000"
    >
      {{ label.uuid }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="LabelColumn.ACTIONS">
    <th mat-header-cell *matHeaderCellDef class="actions-cell"></th>
    <td mat-cell *matCellDef="let label" class="actions-cell">
      <button
        class="icon-button"
        type="button"
        (click)="editClicked.emit(label); $event.stopPropagation()"
        data-cy="label-edit"
      >
        <i class="ri-pencil-line"></i>
      </button>
      <button
        class="icon-button"
        type="button"
        [disabled]="colorActionDisabled"
        (click)="colorClicked.emit(label); $event.stopPropagation()"
        data-cy="label-color"
      >
        <i class="ri-palette-line"></i>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let label; columns: displayedColumns" class="clickable-row"></tr>
  </table>
</div>
